import EnvConfig from '@Config/env.config';
import axios from 'axios';
import { CardHoldersAdapter } from '../adapters/CardHoldersAdapter';
import { ICardHolderType } from '../types/ICardHolderType';

const ROOT_URL = EnvConfig.API_URL;

export async function getAccountRouting(payload: ICardHolderType) {
  console.log('Payload: ', payload);
  const response = await axios.get(`${ROOT_URL}/cardholders`);
  return CardHoldersAdapter.adapt(response.data);
}

export async function updateAccountRouting(payload: ICardHolderType) {
  console.log('Payload: ', payload);
  const response = await axios.get(`${ROOT_URL}/cardholders`);
  return CardHoldersAdapter.adapt(response.data);
}

export async function getCommissionSettings(payload: ICardHolderType) {
  console.log('Payload: ', payload);
  const response = await axios.get(`${ROOT_URL}/cardholders`);
  return CardHoldersAdapter.adapt(response.data);
}

export async function updateCommissionSettings(payload: ICardHolderType) {
  console.log('Payload: ', payload);
  const response = await axios.get(`${ROOT_URL}/cardholders`);
  return CardHoldersAdapter.adapt(response.data);
}
